import { isAxiosError } from 'axios';
import type { ApiResponse } from '@/shared/types';

/**
 * Helpers para leer errores de las peticiones sin recurrir a `any`.
 *
 * El backend responde los errores con el envoltorio `ApiResponse`
 * (`{ success: false, error: { message, statusCode, timestamp } }`), así que el mensaje
 * útil está en `response.data.error.message`. Los `catch` también pueden recibir
 * excepciones propias (`new Error(...)`), que no tienen `response`.
 */

/** Mensaje que devolvió el backend en el envoltorio `ApiResponse`, si la respuesta lo trae. */
export function backendErrorMessage(error: unknown): string | undefined {
  return isAxiosError<ApiResponse>(error) ? error.response?.data?.error?.message : undefined;
}

/** Código de estado HTTP de la respuesta, cuando el error viene de una petición. */
export function errorStatus(error: unknown): number | undefined {
  return isAxiosError(error) ? error.response?.status : undefined;
}

/** Mensaje de la excepción (`Error.message`), si lo hay y no está vacío. */
export function exceptionMessage(error: unknown): string | undefined {
  return error instanceof Error && error.message ? error.message : undefined;
}
